import { Module, VuexModule, Action, Mutation, getModule } from 'vuex-module-decorators'
import store from '@/store'
import { CarritoItem, Carrito } from '@/types/types'
import { CarritoService } from '@/services/CarritoService'
@Module({
  namespaced: true,
  name: 'carritos',
  store,
  dynamic: true
})
class CarritoModule extends VuexModule {
  items: CarritoItem[] = []
  service = new CarritoService()

  @Action({ commit: 'emptyItems' })
  cleanItems () {
    return []
  }

  @Action
  addItem (item: CarritoItem) {
    this.context.commit('setItem', item)
  }

  @Action
  removeIem (id: string) {
    this.context.commit('deleteItem', id)
  }

  @Action({ commit: 'setItems' })
  leadCarrito () {
    return JSON.parse(window.localStorage.getItem('vuex') as string).items
  }

  @Action
  async savePedido (carrito: Carrito) {
    await this.service.create(carrito)
  }

  @Action
  async updatePedido (carrito: Carrito) {
    await this.service.update(carrito)
  }

  @Mutation
  emptyItems (items: CarritoItem[]) {
    this.items = items
  }

  @Mutation
  setItem (item: CarritoItem) {
    this.items = [...this.items, item]
  }

  @Mutation
  setItems (items: CarritoItem[]) {
    this.items = [...this.items, ...items]
  }

  @Mutation
  deleteItem (id: string) {
    this.items = this.items.reduce((accum, item) => {
      if (item.id !== id) {
        accum = [...accum, item]
      }
      return accum
    }, [] as CarritoItem[])
  }

  get countItems () {
    return this.items.length
  }

  get total () {
    return this.items.reduce((accum, item) => accum + item.sub_total, 0)
  }
}
export default getModule(CarritoModule)
